// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-searchbar {
  box-shadow: none;
  border-top: 1px solid #e4dfdf;
}

.custom-card-margin {
  margin: 2px 11px 2px 11px !important;
}

.list-md {
  padding-top: none !important;
  padding-bottom: none !important;
}

.menu-content.pane:not(.menu-animated) .scroll {
  -webkit-transform: translate3d(0px, 0px, 0px) scale(1) !important;
}

.height-scroll {
  height: calc(100vh - 109px);
  overflow: auto;
}

.notification-scroll {
  height: calc(100vh - 210px);
  overflow: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/notifications/notifications.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,6BAAA;AACF;;AAGA;EACE,oCAAA;AAAF;;AAEA;EACE,4BAAA;EACA,+BAAA;AACF;;AACA;EACE,iEAAA;AAEF;;AACA;EACE,2BAAA;EACA,cAAA;AAEF;;AAAA;EACE,2BAAA;EACA,cAAA;AAGF","sourcesContent":["ion-searchbar {\n  box-shadow: none;\n  border-top: 1px solid #e4dfdf;\n  // width: calc(100% - 20px);\n}\n\n.custom-card-margin {\n  margin: 2px 11px 2px 11px !important;\n}\n.list-md {\n  padding-top: none !important;\n  padding-bottom: none !important;\n}\n.menu-content.pane:not(.menu-animated) .scroll {\n  -webkit-transform: translate3d(0px, 0px, 0px) scale(1) !important;\n}\n\n.height-scroll{\n  height: calc(100vh - 109px);\n  overflow: auto;\n}\n.notification-scroll{\n  height: calc(100vh - 210px);\n  overflow: auto;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
